module.exports = __webpack_public_path__ + "img/healthyhabits.e1ca325b.jpg";